<template>
  <ApplicationContext
    ref="context"
    :application="application"
    :workspace="workspace"
  >
    <template #additional-context-items>
      <li
        v-if="
          $hasPermission(
            'database.create_table',
            application,
            application.workspace.id
          )
        "
        class="context__menu-item"
      >
        <a class="context__menu-item-link" @click="openCreateTableModal()">
          <i class="context__menu-item-icon iconoir-plus"></i>
          {{ $t('sidebar.createTable') }}
        </a>
      </li>
      <li class="context__menu-item">
        <!-- Origem Flow: resumo da semana para o cliente (link público). -->
        <a class="context__menu-item-link" @click="openDigestModal()">
          <i class="context__menu-item-icon iconoir-send-diagonal"></i>
          {{ $t('sidebar.weeklyDigest') }}
        </a>
      </li>
      <li class="context__menu-item">
        <nuxt-link
          :to="{
            name: 'database-api-docs-detail',
            params: {
              databaseId: application.id,
            },
          }"
          class="context__menu-item-link"
        >
          <i class="context__menu-item-icon iconoir-book"></i>
          {{ $t('sidebar.viewAPI') }}
        </nuxt-link>
      </li>
    </template>
  </ApplicationContext>
  <CreateTableModal ref="createTableModal" :database="application" />
  <ClientDigestModal ref="digestModal" :database="application" />
</template>

<script>
import ApplicationContext from '@baserow/modules/core/components/application/ApplicationContext.vue'
import applicationContext from '@baserow/modules/core/mixins/applicationContext'
import CreateTableModal from '@baserow/modules/database/components/table/CreateTableModal'
import ClientDigestModal from '@baserow/modules/database/components/digest/ClientDigestModal'

export default {
  components: {
    ApplicationContext,
    CreateTableModal,
    ClientDigestModal,
  },
  mixins: [applicationContext],
  props: {
    application: {
      type: Object,
      required: true,
    },
    workspace: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openCreateTableModal() {
      this.hide()
      this.$refs.createTableModal.show()
    },
    openDigestModal() {
      this.hide()
      this.$refs.digestModal.show()
    },
  },
}
</script>
